export default {
  'Add Cut': 'Добавить вырез',
}